import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime-corejs3/helpers/applyDecoratedDescriptor";

var _dec, _class, _class2;

import React, { Component } from 'react';
import { autobind } from 'core-decorators';
import { styled, StyleSheet } from '@rexlabs/styling';
import { TextInput } from '@rexlabs/text-input';
import PasswordToggle from './toggle-password';
var PasswordInput = (_dec = styled(StyleSheet({
  pointer: {
    cursor: 'pointer'
  },
  text: {
    fontFamily: 'sans-serif',
    width: 200,
    height: 40,
    '&:hover': {
      color: 'aqua'
    }
  }
})), _dec(_class = (_class2 =
/*#__PURE__*/
function (_Component) {
  _inherits(PasswordInput, _Component);

  function PasswordInput(props) {
    var _this;

    _classCallCheck(this, PasswordInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PasswordInput).call(this, props));
    _this.state = {
      showPassword: _this.props.showPassword || false
    };
    return _this;
  }

  _createClass(PasswordInput, [{
    key: "baseToggle",
    value: function baseToggle() {
      this.setState(function (prevState) {
        return {
          showPassword: !prevState.showPassword
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          onToggle = _this$props.onToggle,
          _this$props$Icon = _this$props.Icon,
          Icon = _this$props$Icon === void 0 ? PasswordToggle : _this$props$Icon,
          rest = _objectWithoutProperties(_this$props, ["onToggle", "Icon"]);

      var showPassword = this.state.showPassword;

      var handleClick = function handleClick() {
        _this2.baseToggle();

        if (onToggle !== undefined) {
          onToggle(showPassword);
        }
      };

      return React.createElement(TextInput, _extends({
        suffix: React.createElement(Icon, {
          showPassword: showPassword,
          onClick: handleClick
        }),
        type: showPassword ? 'text' : 'password'
      }, rest));
    }
  }]);

  return PasswordInput;
}(Component), (_applyDecoratedDescriptor(_class2.prototype, "baseToggle", [autobind], _Object$getOwnPropertyDescriptor(_class2.prototype, "baseToggle"), _class2.prototype)), _class2)) || _class);
export default PasswordInput;